import {Button, makeStyles} from "@material-ui/core";
import TableContainer from "@material-ui/core/TableContainer";
import Table from "@material-ui/core/Table";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import CustomCheckBox from "../../experienceManager/participantsDashboard/component/CustomCheckbox";
import {useCallback, useEffect, useState} from "react";
import {getHubs, moveNextPage, updateUserMetrics} from "../../../../../store/actions/creator/creatorExperienceBuilder";
import {useDispatch, useSelector} from "react-redux";
import AutorenewIcon from '@material-ui/icons/Autorenew';
import clsx from 'clsx';
import {useHistory} from "react-router";
import {
  addNewParticipants,
  getManageHubs,
  onUpdateSelectedHubs
} from "../../../../../store/actions/creator/creatorExperienceManager";
import {BackDropAnalyzeLoading} from "../../../../atoms/commonLoadings";
import CustomSnackBar from "../../experienceManager/participantsDashboard/component/CustomSnackBar";

const useStyles = makeStyles(() => ({
  root: {
    paddingTop: "80px",
    fontFamily: 'roboto-regular',
    height: '100%',
    overflowX: 'hidden',
  },
  content: {
    minHeight: '100%',
    padding: '0 0px 100px 0px',
    width: '100%',
    position: 'relative',
    '@media (min-width: 2000px)': {
      width: 1600
    },
    '@media (max-width: 600px)': {
      padding: '55px 0px 10px 0px'
    },
  },
  paper: {
    width: '100%',
    marginBottom: '16px',
    paddingBottom: '24px',
    paddingLeft: '16px',
    paddingRight: '16px',
    borderRadius: 10,
    color: '#263238',
    backgroundColor: '#fff'
  },
  table: {
    minWidth: 750,
    '@media (max-width: 600px)': {
      width: '100%',
      minWidth: 'unset'
    }
  },
  tableHeadText: {
    fontFamily: 'roboto-bold',
    fontSize: 12,
    textTransform: 'uppercase',
    lineHeight: 1.5,
    color: '#606B76',
    '@media (max-width: 1025px)': {
      fontSize: 10
    }
  },
  tableRowNormal: {
    fontFamily: 'roboto-regular',
    fontSize: 14,
    color: '#606B76',
    backgroundColor: '#FFFFFF !important',
  },
  tableRowHover: {
    backgroundColor: '#F2F7FC !important'
  },
  tableRowSelected: {
    backgroundColor: '#F2F7FC !important'
  },
  tableRoot: {
    width: '100%',
    position: 'relative',
    height: '500px',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': {
      width: 10
    },
    '&::-webkit-scrollbar-track': {
      border: '1px solid #D9D9D9'
    },
    '&::-webkit-scrollbar-thumb': {
      background: '#D9D9D9'
    }
  },
  actionBtnDiv: {
    position: 'absolute',
    right: 20,
    marginTop: 25
  },
  addBtn: {
    flex: 1,
    textTransform: "unset",
    backgroundColor: '#017AEF',
    color: '#fff',
    paddingLeft: 50,
    paddingRight: 50,
    marginLeft: 20,
    "&:hover": {
      backgroundColor: '#0f9fef',
    }
  },
  cancelBtn: {
    flex: 1,
    textTransform: "unset",
    backgroundColor: '#FFFFFF',
    color: '#697683',
    fontFamily: 'roboto-regular',
    fontSize: 14,
    boxShadow: 'unset!important',
    "&:hover": {
      backgroundColor: '#e0e0e0',
    }
  },
  uppercase: {
    textTransform: 'uppercase'
  },
  manageBtn:{
    height: 26,
    minWidth: 90,
    background: '#F0F0F0',
    borderRadius: 4,
    color: '#697683',
    fontFamily: 'roboto-regular',
    boxShadow: 'none',
    textTransform: 'none',
    fontSize: 12
  },
  autoRenewDiv: {
    display: 'flex',
    alignItems: 'center'
  },
  renewIcon: {
    width: 16,
    height: 16,
    marginLeft: 8,
    marginBottom: 3,
    cursor: 'pointer'
  },
  spin: {
    animation: "$spin 1s 1",
  },
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(0deg)',
    },
    '100%': {
      transform: 'rotate(360deg)',
    },
  }
}));

interface IHeaderCell {
  id?: string;
  disablePadding?: boolean;
  label?: string;
  numeric?: boolean;
  color?: string;
}

const headerCells: IHeaderCell[] = [
  { id: 'hub_device_id', numeric: false, disablePadding: true, label: '', color: 'primary' },
  { id: 'hub_name', numeric: false, disablePadding: false, label: 'HUB NAME', color: 'primary' },
  { id: 'hub_id', numeric: false, disablePadding: false, label: 'ID#', color: 'default' },
  { id: 'is_live', numeric: false, disablePadding: false, label: 'Connectivity Status', color: 'default' }
];

const HubConnect = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loginUserData = localStorage.getItem("user_data") ? JSON.parse(localStorage.getItem("user_data") || "{}") : "";
  const apolloClient = useSelector((state: any) => state.apolloClient);
  const { managerHubList, managerSelectedHubs, managerLoading } = useSelector((state: any) => state.creatorExperienceManager);
  const { page, hubLists, userMetrics, loading } = useSelector((state: any) => state.creatorExperienceBuilder);
  const { selectedHubs } = userMetrics;
  const [hoverHubId, setHoverHubId] = useState('');
  const [sessionID, setSessionID] = useState(0);
  const [showAlert, setShowAlert] = useState(false);

  useEffect(() => {
    dispatch(updateUserMetrics('selectedHubs', []));
  }, []);

  useEffect(() => {
    const state: any = history.location.state;
    if (state && state.session_id) {
      setSessionID(state.session_id);
    }
  }, [history.location]);

  const isHubChecked = useCallback((hub: any) => {
    let checkedHub;
    if (sessionID !== 0) { // on Setup Tab
      checkedHub = managerSelectedHubs.find((h: any) => h.hub_id === hub.hub_id);
    } else { // experience builder
      checkedHub = selectedHubs.find((h: any) => h.hub_id === hub.hub_id);
    }
    return !!checkedHub;
  }, [sessionID, selectedHubs, managerSelectedHubs]);

  const handleHubCheck = useCallback((hub: any) => {
    if (sessionID !== 0) { // on Setup Tab
      const _hub = managerSelectedHubs.find((h: any) => h.hub_id === hub.hub_id);
      if (_hub) {
        const newCheckedHubs = managerSelectedHubs.filter((h: any) => h.hub_id != hub.hub_id);
        dispatch(onUpdateSelectedHubs(newCheckedHubs));
      } else {
        const originalHubs = [...managerSelectedHubs];
        originalHubs.push({ hub_id: hub.hub_id });
        dispatch(onUpdateSelectedHubs(originalHubs));
      }
    } else { // experience builder
      const _hub = selectedHubs.find((h: any) => h.hub_id === hub.hub_id);
      if (_hub) {
        const newCheckedHubs = selectedHubs.filter((h: any) => h.hub_id != hub.hub_id);
        dispatch(updateUserMetrics('selectedHubs', newCheckedHubs));
      } else {
        const originalHubs = [...selectedHubs];
        originalHubs.push({ hub_id: hub.hub_id });
        dispatch(updateUserMetrics('selectedHubs', originalHubs));
      }
    }
  }, [sessionID, selectedHubs, managerSelectedHubs]);

  const onCancel = useCallback(() => {
    if (sessionID !== 0) { // on Setup tab
      history.go(-1);
    } else { //
      dispatch(updateUserMetrics('selectedHubs', []));
      dispatch(updateUserMetrics('using_hub_connectivity', false));
      dispatch(updateUserMetrics('moderatedInviteWay', 'link'));
      dispatch(moveNextPage(2));
    }
  }, [sessionID]);

  const onAdd = useCallback(() => {
    if (sessionID !== 0) { // on Setup tab
      dispatch(addNewParticipants(apolloClient.client, Number(sessionID), [], managerSelectedHubs, (res: any) => {
        if (res) {
          history.go(-1);
        }
      }))
    } else { // experience builder
      dispatch(moveNextPage(page + 1));
    }
  }, [page, sessionID, managerSelectedHubs]);

  const onRefresh = useCallback(() => {
    if (sessionID !== 0) { // on Setup tab
      const request: any = {session_id: Number(sessionID)};
      if (loginUserData.department_id) {
        request['department_id'] = Number(loginUserData.department_id);
      }
      dispatch(getManageHubs(apolloClient.client, request, (res: boolean) => {
        res && setShowAlert(true);
      }));
    } else { // experience builder
      const request = loginUserData.department_id ? {department_id: Number(loginUserData.department_id)} : {};
      dispatch(getHubs(apolloClient.client, request, (res: boolean) => {
        res && setShowAlert(true);
      }));
    }
  }, [sessionID]);

  const getLoading = useCallback(() => {
    if (sessionID !== 0) { // on Setup tab
      return managerLoading
    } else { // experience builder
      return loading
    }
  }, [sessionID, loading, managerLoading]);

  const isDisableBtn = useCallback(() => {
    if (sessionID !== 0) { // on Setup tab
      return managerSelectedHubs.length === 0;
    } else { // experience builder
      return selectedHubs.length === 0;
    }
  }, [sessionID, selectedHubs, managerSelectedHubs]);

  return (
    <div className={classes.root}>
      <BackDropAnalyzeLoading loading={managerLoading} />
      <CustomSnackBar type={'success'} message={'Successfully Refreshed'} open={showAlert} onClose={() => setShowAlert(false)} />
      <div className={classes.content}>
        <div className='creator-main-title' style={{ marginBottom: 30 }}>
          Which hubs do you want to connect?
        </div>
        <p className="creator-title">
          Ensure hubs are on and associated to your account<br />
          via our setup instructions.
        </p>
        <div className={classes.tableRoot}>
          <div className={classes.paper}>
            <TableContainer>
              <Table
                className={classes.table}
                aria-labelledby="tableTitle"
                size="medium"
                aria-label="enhanced table"
              >
                <TableHead>
                  <TableRow>
                    {headerCells.map((header: any) => (
                      <TableCell
                        key={header.id}
                        align="left"
                        padding="normal"
                        className={classes.tableHeadText}
                      >
                        {header.id === 'is_live' ? (
                          <div className={classes.autoRenewDiv}>
                            <span>{header.label}</span>
                            <AutorenewIcon
                              className={getLoading() ? clsx(classes.spin, classes.renewIcon) : classes.renewIcon}
                              onClick={onRefresh}
                            />
                          </div>
                        ) : (
                          <span>{header.label}</span>
                        )}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {sessionID !== 0 ? (
                    managerHubList.map((hub: any, index: number) => (
                      <TableRow
                        onMouseOver={() => setHoverHubId(hub.hub_id)}
                        onMouseLeave={() => setHoverHubId('')}
                        role="checkbox"
                        tabIndex={-1}
                        key={hub.hub_id}
                        hover={hub.hub_id === hoverHubId}
                        classes={{
                          root: classes.tableRowNormal,
                          hover: classes.tableRowHover,
                          selected: classes.tableRowSelected,
                        }}
                      >
                        <TableCell padding="checkbox">
                          <CustomCheckBox
                            key={`check-box-${hub.hub_id}`}
                            checked={isHubChecked(hub)}
                            onClick={() => handleHubCheck(hub)}
                            inputProps={{ 'aria-labelledby': `enhanced-table-checkbox-${index}` }}
                          />
                        </TableCell>
                        <TableCell scope="row" align="left">
                          { hub.hub_name }
                        </TableCell>
                        <TableCell className={classes.uppercase} scope="row" align="left">
                          { hub.hub_id }
                        </TableCell>
                        <TableCell scope="row" align="left">
                          { hub.is_live ? 'Detected' : 'Not currently detected' }
                        </TableCell>
                      </TableRow>
                    ))
                  ) : (
                    hubLists.map((hub: any, index: number) => (
                      <TableRow
                        onMouseOver={() => setHoverHubId(hub.hub_id)}
                        onMouseLeave={() => setHoverHubId('')}
                        role="checkbox"
                        tabIndex={-1}
                        key={hub.hub_id}
                        hover={hub.hub_id === hoverHubId}
                        classes={{
                          root: classes.tableRowNormal,
                          hover: classes.tableRowHover,
                          selected: classes.tableRowSelected,
                        }}
                      >
                        <TableCell padding="checkbox">
                          <CustomCheckBox
                            key={`check-box-${hub.hub_id}`}
                            checked={isHubChecked(hub)}
                            onClick={() => handleHubCheck(hub)}
                            inputProps={{ 'aria-labelledby': `enhanced-table-checkbox-${index}` }}
                          />
                        </TableCell>
                        <TableCell scope="row" align="left">
                          { hub.hub_name }
                        </TableCell>
                        <TableCell className={classes.uppercase} scope="row" align="left">
                          { hub.hub_id }
                        </TableCell>
                        <TableCell scope="row" align="left">
                          { hub.is_live ? 'Detected' : 'Not currently detected' }
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
        <div className={classes.actionBtnDiv}>
          <Button variant="contained" className={classes.cancelBtn} onClick={onCancel}>
            Cancel
          </Button>
          <Button
            variant="contained"
            className={classes.addBtn}
            disabled={isDisableBtn()}
            onClick={() => onAdd()}
          >
            Add
          </Button>
        </div>
      </div>
    </div>
  )
};

export default HubConnect;